import { JobOpeningIcon } from "../assets/svg/JobOpening";
import { LocationIcon } from "../assets/svg/LocationIcon";
import { DescriptionIcon } from "../assets/svg/DescriptionIcon";
import { AttachmentIcon } from "../assets/svg/AttachmentIcon";

export const tabsData = [
    { label: 'Job Opening', Icon: JobOpeningIcon },
    { label: 'Address Information', Icon: LocationIcon },
    { label: 'Description Information', Icon: DescriptionIcon },
    { label: 'Attachment Information', Icon: AttachmentIcon },
];

export const interviewTabsData = [
    { label: 'Interview Details', Icon: JobOpeningIcon },
    { label: 'Additional information', Icon: DescriptionIcon },
]

export const applicationTabsData = [
    { label: 'Application detail', Icon: JobOpeningIcon },
    { label: 'Attachment information', Icon: DescriptionIcon },
    { label: 'Document Verification', Icon: DescriptionIcon },
    { label: 'LOI', Icon: DescriptionIcon },
]

export const departmentTabsData = [
    { label: 'Department detail', Icon: JobOpeningIcon },
]

export const feedbackTabsData = [
    { label: 'Feedback information', Icon: DescriptionIcon },
]